import { Graphics, Texture, Sprite, Container } from 'pixi.js';
import type { CatalogCard } from './types';

export function cardAura(card?:CatalogCard){
  const name=card?.name.toLowerCase()??'',type=card?.type.toLowerCase()??'';
  if(name.includes('dragon ball'))return {color:0xf3cb76,kind:'dragon-ball'};
  if(name.includes('drill'))return {color:0xba9cff,kind:'drill'};
  if(type.includes('energy'))return {color:0xffba50,kind:'energy'};
  if(type.includes('physical'))return {color:0xf2727d,kind:'physical'};
  if(type.includes('personality')||type==='hero'||type==='villain')return {color:0x8ee7ab,kind:'personality'};
  if(type.includes('non-combat'))return {color:0x72d8d3,kind:'non-combat'};
  return {color:0x8eaeff,kind:'combat'};
}

let halo:Texture|undefined;
function haloTexture(){
  if(halo)return halo;
  const canvas=document.createElement('canvas');canvas.width=160;canvas.height=224;
  const context=canvas.getContext('2d')!;
  // Code-drawn, reusable feathered silhouette; tint provides each card family's aura.
  for(let spread=22;spread>0;spread--){context.fillStyle=`rgba(255,255,255,${.009+(22-spread)*.0004})`;context.beginPath();context.roundRect(28-spread,32-spread,104+spread*2,160+spread*2,12+spread*.45);context.fill();}
  context.globalCompositeOperation='destination-out';context.fillStyle='#fff';context.fillRect(29,33,102,158);
  halo=Texture.from(canvas);return halo;
}

export class CardAura {
  readonly layer=new Container();
  private mist:Sprite;private sparks=new Graphics();
  constructor(readonly id:string,readonly kind:string,readonly color:number,private w:number,private h:number,private seed:number){
    this.mist=new Sprite(haloTexture());this.mist.anchor.set(.5);this.mist.width=w*1.5;this.mist.height=h*1.39;this.mist.tint=color;
    this.layer.addChild(this.mist,this.sparks);this.layer.eventMode='none';
  }
  update(time:number,reduced:boolean,hovered:boolean){
    const phase=reduced?0:time*.0014+this.seed;
    const strength=hovered?1:.85;
    this.layer.alpha=strength;this.mist.alpha=.85+(reduced?0:Math.sin(phase)*.15);
    const g=this.sparks.clear(),w=this.w,h=this.h,c=this.color;
    for(const [spread,alpha]of [[14,.035],[8,.06],[3,.21]]as const)g.roundRect(-w/2-spread,-h/2-spread,w+spread*2,h+spread*2,8+spread*.3).stroke({color:c,width:spread===3?1.2:spread,alpha});
    if(reduced)return;
    // Tapered ribbons and rising motes create a charging aura, rather than another border.
    for(let side=-1;side<=1;side+=2)for(let i=0;i<4;i++){
      const progress=(phase*.34+i*.25+(side>0?.13:0))%1,yy=h*.5-progress*h;
      const wave=Math.sin(phase*2.1+i*2.3),xx=side*(w/2+11+wave*5),length=39+19*Math.sin(phase+i);
      const fade=Math.sin(progress*Math.PI);
      g.poly([xx,yy+length*.5,xx+side*(11+wave*4),yy,xx+side*3,yy-length]).fill({color:c,alpha:fade*.32});
      g.circle(xx+side*5,yy-length-6,1.2+fade).fill({color:c,alpha:fade*.8});
    }
  }
}
